
    import './styles.scoped.css';
    export default {
  "error-icon-shake-wrapper": "awsui_error-icon-shake-wrapper_14mhv_z9i4z_98",
  "awsui-motion-shake-horizontally": "awsui_awsui-motion-shake-horizontally_14mhv_z9i4z_1",
  "error-icon-scale-wrapper": "awsui_error-icon-scale-wrapper_14mhv_z9i4z_125",
  "awsui-motion-scale-popup": "awsui_awsui-motion-scale-popup_14mhv_z9i4z_1",
  "error": "awsui_error_14mhv_z9i4z_98",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_14mhv_z9i4z_1",
  "root": "awsui_root_14mhv_z9i4z_169",
  "label": "awsui_label_14mhv_z9i4z_181",
  "info": "awsui_info_14mhv_z9i4z_194",
  "description": "awsui_description_14mhv_z9i4z_199",
  "constraint": "awsui_constraint_14mhv_z9i4z_200",
  "hints": "awsui_hints_14mhv_z9i4z_207",
  "constraint-has-error": "awsui_constraint-has-error_14mhv_z9i4z_208",
  "secondary-control": "awsui_secondary-control_14mhv_z9i4z_212",
  "controls": "awsui_controls_14mhv_z9i4z_216",
  "label-hidden": "awsui_label-hidden_14mhv_z9i4z_216",
  "control": "awsui_control_14mhv_z9i4z_216",
  "error__message": "awsui_error__message_14mhv_z9i4z_235",
  "visually-hidden": "awsui_visually-hidden_14mhv_z9i4z_239"
};
  